module.exports = __webpack_public_path__ + "img/bg_nucleic_acid.b29eeccd.jpeg";